import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cf00a1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row state" }
const _hoisted_2 = { class: "col-3 mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Wollen sie diese Evaluierungsrunde wirklich stoppen?", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Alle offenen Evaluierungen werden im Zuge dessen, abgeschlossen.", -1))
const _hoisted_5 = {
  key: 0,
  class: "col-12 mb-3"
}
const _hoisted_6 = { class: "row mt-3 mb-0 header smalltext align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, "#", -1))
const _hoisted_8 = { class: "col-3" }
const _hoisted_9 = { class: "col-4" }
const _hoisted_10 = { class: "col-4" }
const _hoisted_11 = { class: "col-1" }
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = { class: "col-4" }
const _hoisted_14 = { class: "col-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalButton = _resolveComponent("ModalButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.meta?.current)
          ? (_openBlock(), _createBlock(_component_ModalButton, {
              key: 0,
              class: "modalbutton",
              link: "stopUmfrage"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", null, _toDisplayString(_ctx.$t('management.feedbacks.stop')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Modal, {
          link: "stopUmfrage",
          title: "Evaluierungsrunde stoppen"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("p", null, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args)))
              }, _toDisplayString(_ctx.$t('management.feedbacks.stop')), 1)
            ])
          ]),
          _: 1
        }),
        (!_ctx.meta?.current)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.start && _ctx.start(...args)))
            }, _toDisplayString(_ctx.$t('management.feedbacks.start')), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.meta?.current)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('management.feedbacks.current')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('management.feedbacks.start_text')), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('management.feedbacks.end_text')), 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('management.grades.state')), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.umfragen, (umfrage) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row umfrageentry align-items-center",
        key: umfrage.id
      }, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(umfrage.id), 1),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.format(new Date(umfrage.createdat), 'dd.MM.yyyy kk:mm')), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.format(new Date(umfrage.endedat), 'dd.MM.yyyy kk:mm')), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(umfrage.running ? _ctx.$t('management.feedbacks.running') : _ctx.$t('management.feedbacks.finished')), 1)
      ]))
    }), 128))
  ], 64))
}